module.exports = __webpack_public_path__ + "img/attach_file_bai.09260d24.svg";